module.exports = __webpack_public_path__ + "media/images/ponto_de_interrogacao-776d04917012ab7e226fff0bdba4cbd4.svg";